<template>
  <div>
    <b-table
        :items="B2BOrders"
        :fields="B2BOrdersHeaders"
        hover
        responsive
        :per-page="perPage"
        :busy="B2BOrdersLoading"
        style="font-size:12px;"
        head-row-variant="info"
        table-variant="white"
        show-empty
    >
      <template #empty="scope">
        <h6 class="text-center my-5">
          {{ scope.loading ? "Lütfen Bekleyin" : noOrderMessage }}
        </h6>
      </template>
      <template #cell(status)="data">
        <v-chip small color="primary" label outlined v-if="data.item.status === 1">Beklemede</v-chip>
        <v-chip small color="success" label outlined v-if="data.item.status === 2">Onaylandı</v-chip>
        <v-chip small color="amber" label outlined v-if="data.item.status === 3">Faturalandı</v-chip>
        <v-chip small color="danger" label outlined v-if="data.item.status === 4">Reddedildi</v-chip>
        <v-chip small color="info" label outlined v-if="data.item.status === 5">Proje Aşamasında</v-chip>
        <v-chip small color="primary" label outlined v-if="data.item.status === 6">Sipariş Aşamasında</v-chip>
      </template>
      <template #cell(user)="data">
        {{ data.item.user.firstName + " " + data.item.user.lastName }}
      </template>
      <template #cell(process)="data">
        <div>
          <v-menu
              :v-model="showActionsMenu"
              bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  class="mx-1"
                  small
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  @click="showActionsMenu = data.item.code"
              >
                İşlemler
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                  @click="openSiparisDetailDialog(data.item.orderNumber,data.item.id, data.item.currencyType, data.item.currentCode); closeMenu();"
              >
                <v-list-item-icon>
                  <v-icon color="primary"> mdi-eye</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Detay Görüntüle</v-list-item-title>
              </v-list-item>

              <v-list-item
                  v-if="data.item.status === 2"
                  v-show="userRoleId === '1' || userRoleId === 1"
                  @click="_erpStatusChangeOrder(data.item.id); closeMenu();"
              >
                <v-list-item-icon>
                  <v-icon color="amber">mdi-swap-horizontal</v-icon>
                </v-list-item-icon>
                <v-list-item-title>ERP Durum Değiştir</v-list-item-title>
              </v-list-item>

              <v-list-item
                  v-if="data.item.status === 1"
                  v-show="(userRoleId === '1' || userRoleId === 1) || checkSalesPersonOrderApprove"
                  @click="_approveOrder(data.item); closeMenu();"
              >
                <v-list-item-icon>
                  <v-icon color="success darken-1"> mdi-check-decagram</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Siparişi Onayla</v-list-item-title>
              </v-list-item>
              <v-list-item
                  v-if="(data.item.status === 5 || data.item.status === 6) && userRoleId === '3'"
                  @click="checkDemoProject(data.item); closeMenu();"
              >
                <v-list-item-icon>
                  <v-icon color="success darken-1"> mdi-send-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Onaya Gönder</v-list-item-title>
              </v-list-item>

              <v-list-item
                  v-if="data.item.status === 5 || (data.item.status === 1 ? userRoleId === '1' || userRoleId === 1 : false) "
                  @click="openOrderEditDialog(data.item.orderNumber, data.item.id); closeMenu();"
              >
                <v-list-item-icon>
                  <v-icon color="brown">mdi-playlist-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Sipariş Düzenle</v-list-item-title>
              </v-list-item>

              <v-list-item
                  v-if="data.item.status !== 2"
                  v-show="userRoleId === '1' || userRoleId === 1"
                  @click="_deleteOrder(data.item.id,data.item.stockCode,data.item.basketCode); closeMenu();"
              >
                <v-list-item-icon>
                  <v-icon color="danger"> mdi-basket-remove</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Siparişi Sil</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

      </template>
      <template #cell(paymentMethod)="data">
        {{ data.item.paymentMethod ? data.item.paymentMethod.name : '' }}
      </template>
      <template #table-busy>
        <div class="text-center">
          <b-spinner
              variant="primary"
              size="lg"
              label="Text Centered"
          ></b-spinner>
        </div>
      </template>
    </b-table>
    <OrderDetailsDialog
        :order-current-code="currentCode"
        :orderCurrencyType="orderCurrencyType"
        :showDialog="orderDetailDialog"
        :orderNumber="orderNumber"
        :orderId="orderId"
        :title="'Sipariş Detay'"
        @dialogChange="(e) => (orderDetailDialog = e)"
    ></OrderDetailsDialog>
    <EditOrderDialog
        :showDialog="orderEditDialog"
        :orderNumber="orderNumber"
        :orderId="orderId"
        :title="'Sipariş Detay'"
        @dialogChange="(e) => (orderEditDialog = e)"
    ></EditOrderDialog>
    <DemoProjectDialog
        :showDialog="demoProjectDialog"
        :title="'Demo Proje Sözleşmesi'"
        @dialogChange="(e) => (demoProjectDialog = e)"
        :order="order"
    ></DemoProjectDialog>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import OrderDetailsDialog from "@/components/orders/B2BOrders/dialogs/OrderDetailsDialog.vue";
import EditOrderDialog from "@/components/orders/B2BOrders/dialogs/EditOrderDialog";
import DemoProjectDialog from "@/components/project/dialogs/DemoProjectDialog.vue";

export default {
  components: {
    DemoProjectDialog,
    OrderDetailsDialog,
    EditOrderDialog
  },
  props: {
    selectedProjectCode: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState("order", ["B2BOrders", "B2BOrdersHeaders", "B2BOrdersLoading", "noOrderMessage"]),
    ...mapState("auth", ["user"]),
    ...mapState("settings", ["erpSettings"]),
    ...mapState("payment", ["paymentMethodList"]),
    ...mapState("current",["salesPersonList"]),
    checkSalesPersonOrderApprove() {
      return this.erpSettings.salesPersonOrderApprove;
    },
    statusOptions: function () {
      let options = [
        {value: null, text: 'Tüm Durumlar'},
        {value: 1, text: 'Beklemede'},
        {value: 2, text: 'Onaylandı'},
        {value: 3, text: 'Faturalandı'},
        {value: 4, text: 'Reddedildi'}]
      if (this.erpSettings.cartProjectProcess)
        options.push({value: 5, text: 'Proje Aşamasında'},{value: 6, text: 'Sipariş Aşamasında'})
      return options;
    }
  },
  data() {
    return {
      showActionsMenu: false,
      userRoleId: this.$store.state.auth.user.RoleGroupId,
      selectRow: false,
      orderDetailDialog: false,
      orderDetailDialogData: null,
      orderNumber: null,
      orderId: null,
      orderEditDialog: false,
      orderCurrencyType: null,
      currentCode: null,
      demoProjectDialog: false,
      order: null,
      perPage: 10,
      currentPage: 1,

    };
  },
  methods: {
    ...mapActions("current", ["fetchSalesPersonList","fetchCurrentList"]),
    ...mapActions("payment", ["fetchPaymentMethodList"]),
    ...mapActions("order", ["fetchOrdersByProjectCode", "erpStatusChangeOrder", "deleteOrder", "approveOrder", "fetchDemoProjectHTML"]),

    async checkDemoProject(item) {
      this.order = item;
      if (item.projectCode) {
        if (item.projectCode.substring(0, 1) === 'D') {
          await this.fetchDemoProjectHTML({
            params: {},
            body: {},
            urlSegments: [item.id]
          });
          this.openDemoProjectContractDialog();
        } else {
          await this._approveOrder(item);
        }
      }
    },
    async _approveOrder(item) {
      await this.approveOrder({
        params: {},
        body: {},
        urlSegments: [item.id]
      });
      await this._fetchB2BOrders();
    },
    closeMenu() {
      this.showActionsMenu = false;
    },
    openSiparisDetailDialog(orderNumber, orderId, currencyType, currentCode) {
      this.orderCurrencyType = currencyType;
      this.orderNumber = orderNumber;
      this.orderId = orderId;
      this.orderDetailDialog = true;
      this.currentCode = currentCode;
    },
    openOrderEditDialog(orderNumber, orderId) {
      this.orderNumber = orderNumber;
      this.orderId = orderId;
      this.orderEditDialog = true;
    },
    async _fetchB2BOrdersByProjectCode() {
      await this.fetchOrdersByProjectCode({
        params: {
          PageNumber: this.currentPage,
          PageSize: this.perPage,
          ProjectCode: this.selectedProjectCode
        }
      })
    },
    async _erpStatusChangeOrder(orderId) {
      await this.erpStatusChangeOrder({
        params: {},
        body: {
          OrderId: orderId,
          Value: true
        }
      })
      await this._fetchB2BOrdersByProjectCode();
    },
    async _deleteOrder(orderId, stockCode, basketCode) {
      await this.deleteOrder({
        params: {
          ...(!(orderId === "" || orderId == null)) && {orderId: orderId},
          ...(!(stockCode === "" || stockCode == null)) && {stockCode: stockCode},
          ...(!(basketCode === "" || basketCode == null)) && {basketCode: basketCode},
        },
        body: {}
      })
      await this._fetchB2BOrdersByProjectCode();

    },
    openDemoProjectContractDialog() {
      this.demoProjectDialog = true;
    }
  },
  watch: {
    "selectedProjectCode": function () {
      this._fetchB2BOrdersByProjectCode();
    }
  },

  mounted() {
    this.fetchSalesPersonList({
      params: {

      },
      body: {

      }
    });
    this.fetchPaymentMethodList({
      params: {
        userId: this.user.UserId
      },
      body: {}
    })
    this._fetchB2BOrdersByProjectCode();
  }
};
</script>
